import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation } from 'react-query';

function useChangePassword() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function changePassword(data) {
    return privateFetch.put(`/v1/changepassword`, data);
  }
  return useMutation(changePassword, {
    onSuccess() {},
    onError() {},
  });
}

export default useChangePassword;
